import { render, staticRenderFns } from "./TabVotings.vue?vue&type=template&id=a7b73230"
import script from "./TabVotings.vue?vue&type=script&lang=js"
export * from "./TabVotings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports